<template>
  <router-view
    v-if="loaded"
    v-title="title"
  />
</template>

<script>
import { getUrlParam, translationCase } from '@/utils/helper';
import { strip } from '@/utils/domHelper';
import doLogin from '@/apis/login';
import { getAwardStatus } from '@/apis/survey';
import lottery from '@/components/lottery';
import { loadLanguageAsync } from '@/lang';
import { mapState } from 'vuex';
import answerMixin from './answer/answer-mixin';
import { getAnswerHistoryCount } from './answer/answer-utils';

export default {
  name: 'Home',

  mixins: [answerMixin],

  data() {
    return {
      loaded: false,
      title: '',
    };
  },

  computed: {
    ...mapState(['answers']),
  },

  async created() {
    const { pathname } = window.location;
    const loading = this.$buefy.loading.open();
    let lang = getUrlParam('lang') || 'zh-CHS';
    this.sid = getUrlParam('sid');

    if (!this.sid || this.sid.length !== 24) {
      this.$router.replace('/other?type=notexist');
      this.$nextTick(() => {
        this.loaded = true;
        loading.close();
      });
      return;
    }

    const { body } = document;
    const { query } = this.$route;

    if (this.$previewCode) {
      body.classList.add('preview');
    }

    try {
      const { data, meta } = await this.$store.dispatch('requestSurvey', {
        id: this.sid,
        previewCode: this.$previewCode,
      });

      this.title = strip(data.title);
      const { verification, amsLottery, isSaveAnswersHistory } = meta.configs;
      lang = meta?.configs?.language || lang;
      await loadLanguageAsync(translationCase(lang));
      if (amsLottery) {
        try {
          const res = await getAwardStatus(this.sid);
          const { status } = res.data;
          if (!status) {
            lottery({
              sid: this.sid,
            });
          }
        } catch (e) {
        }
      }

      if (pathname === '/') {
        if (isSaveAnswersHistory && getAnswerHistoryCount(this?.answers) > 0 && !verification) {
          this.routeReplace('answer-history', query, lang);
          return;
        }

        if (!verification) {
          this.routeReplace('welcome', query, lang);
        } else {
          this.routeReplace('verification', query, lang);
        }
      }
    } catch (e) {
      lang = e.meta?.configs?.language || lang;
      await loadLanguageAsync(translationCase(lang));
      let isNormal = false;

      if (e.error) {
        isNormal = true;
        if (e.error.code === 10010) {
          doLogin(this.sid, e.meta?.platforms || [], () => {
            query.type = 'login_parameters_missing';
            this.routeReplace('other', query, lang);
          });
          return;
        }

        if (e.error.code === 10023) {
          const whitelistType = e.meta?.configs?.whitelistType;
          const whiteQuery = {
            ...query, whitelistType,
          };
          this.routeReplace('whitelist', whiteQuery, lang);
          return;
        }

        switch (e.error.code) {
          case 10007:
            query.type = 'answered';
            break;
          case 10006:
            query.type = 'notexist';
            break;
          case 10008:
            query.type = 'closed';
            break;
          case 10011:
            query.type = 'answered';
            break;
          case 10012:
            query.type = 'notinwhitelist';
            break;
          case 10024:
            query.type = 'loginFailed';
            break;
          case 10026:
            query.type = 'publishing';
            break;
          default:
            isNormal = false;
            query.type = 'unknown';
            break;
        }
      } else {
        // 服务异常
        query.type = 'unknown';
      }
      if (!isNormal) {
        console.error(e);
      }

      this.routeReplace('other', query, lang);
    } finally {
      this.$nextTick(() => {
        this.loaded = true;
        loading.close();
      });
    }
  },
};
</script>
